export class Config {
    id: string;
    clientId: string;
    analyticsId: string;
    enabled: boolean;
    endUserEnabled: boolean;
    text: string;
    image: string;
    features: Features = new Features();
    functions: AppFunctions = new AppFunctions();
    sdid: string;
    languages: string[];
    viewPercent: number;
    headerColour: string;
    bgColour: string;
    buttonColour: string;
    buttonTextColour: string;
}

export class Features {
    ar: boolean;
    map: boolean;
    video: boolean;
    gallery: boolean;
    journey: boolean;
    competition: boolean;
    phone: boolean;
    website: boolean;
    information: boolean;
    gps: boolean;
    trigger: boolean;
    appStore: boolean;
    interactive: boolean;
    interactiveAR: boolean;
    blog: boolean;
    audio: boolean;
    colour: boolean;
    logo: boolean;
}

export class AppFunctions {
    qrImageGen?: boolean;
    galleryImageGen?: boolean;
    tts?: boolean;
    collectAnalytics?: boolean;
    showAnalytics?: boolean;
}